import React, { useContext } from "react";
import { RegistrationFormContext } from "./types";
import { InputRadio } from "../../../../HtmlComponents/InputRadio";
import { TextAreaElement } from "../../../../HtmlComponents/TextAreaElement";

const Section7 = () => {
  const {
    workPracticeIn, setWorkPracticeIn,
    remplacements, setRemplacements
  } = useContext(RegistrationFormContext);

  return (
    <>
      <div>
        <p className='font-bold text-main'>{"30) "}Exerces-vous-en: </p>
        <InputRadio 
          checked={workPracticeIn === "Association" && true} 
          labelName="Association"
          id="Association" 
          value={"Association"} 
          setValue={setWorkPracticeIn}
        />
        <InputRadio 
          checked={workPracticeIn === "Societe civile professionnelle" && true} 
          labelName="Societe civile professionnelle"
          id="SocieteCivileProfessionnelle" 
          value={"Societe civile professionnelle"} 
          setValue={setWorkPracticeIn}
        />
        <InputRadio 
          checked={workPracticeIn === "Remplacement de confréres" && true} 
          labelName="Remplacement de confréres"
          id="RemplacementDeConfréres" 
          value={"Remplacement de confréres"} 
          setValue={setWorkPracticeIn}
        />
        <InputRadio 
          checked={workPracticeIn === "Selon une autre modalité" && true} 
          labelName="Selon une autre modalité"
          id="SelonUneAutreModalité" 
          value={"Selon une autre modalité"} 
          setValue={setWorkPracticeIn}
        />
      </div>
      <TextAreaElement labelClass="text-main" labelName={`31) Avez-vous effectué des remplacements`} placeholder="Énumérez les adresses et les noms des médecins Remplacés, La date et la durée au cours des deux dernières années" value={remplacements} setValue={setRemplacements}/>
      
    </>
  );
};

export default Section7;
